import {Component, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {DataService} from "../../services/data.service";
import {UtilService} from "../../services/util.service";
import {Router} from "@angular/router";
import {HttpErrorResponse} from "@angular/common/http";

@Component({
  selector: 'app-contract-templates',
  templateUrl: './contract-templates.component.html',
  styleUrls: ['./contract-templates.component.scss']
})
export class ContractTemplatesComponent implements OnInit {

  loading = false;
  fileLoading = false;
  productOptions: any[] = [];
  stateOptions: any[] = [];
  marketOptions: any[] = [];
  contractForm: FormGroup;
  showImpersonateText: boolean = false;
  dropDownOptions: object[] = [{label: "Broker Name", value: "brokername"}, {label: "Broker ID", value: "id"}, {label: "Sales Person", value: "salesperson"}];
  displayedColumns: any[] = [
    {field: 'product', label: 'Product'},
    {field: 'state', label: 'State'},
    {field: 'market', label: 'Market'},
    {field: 'name', label: 'File Name'},
    {field: 'requestUser', label: 'Uploader Name'},
    {field: 'dateOfRecord', label: 'Upload Date', type: 'date'}
  ];
  dataSource;
  @ViewChild('activeContractTable') activeContractTable;
  @ViewChild('attachments') attachments;

  constructor(public form: FormBuilder, private dataService: DataService, private utilService: UtilService, private route: Router) { }

  ngOnInit(): void {
    // this.getAdminData();
    this.contractForm = this.form.group({
      product: ['', Validators.required],
      state: ['', Validators.required],
      market: ['', Validators.required],
      file: ['', Validators.required]
    })
    this.getActiveContracts();
  }
  async getActiveContracts(){
    let self = this;
    this.loading = true;
    self.dataService.getContractTemplateInfo('listactive').subscribe((res: any) => {
      // this.showImpersonateText = true;
        this.dataSource = res;
      self.activeContractTable.initializeTable();
      this.loading = false;
    }, (err: HttpErrorResponse) => {
      this.loading = false;
      this.utilService.errorMessage('Fetch Failed')
    });

    this.productOptions = await this.getDropdownOptions('listofproducts') as any[];
    this.stateOptions = await this.getDropdownOptions('listofstates') as any[];
    this.marketOptions = await this.getDropdownOptions('listofmarkets') as any[];
  }
  getDropdownOptions(param){
    return new Promise((resolve, reject) => {
      this.dataService.getContractTemplateInfo(param).subscribe(res => {
        res = res.map(item => ({label: item, value: item}))
        resolve(res)
      }, err => resolve([]));
    })
  }
  onFileDropped($event, field){
    this.contractForm.get(field).setValue($event);
  }
  uploadTemplate(){
    this.fileLoading = true;
    let attachments = this.utilService.convertToUploadFileFormat(this.contractForm.get('file').value);
    this.dataService.uploadContractTemplate(this.contractForm.value, attachments).subscribe(res => {
      this.utilService.successMessage('Template Uploaded');
      this.contractForm.reset();
      this.attachments.reset();
      this.fileLoading = false;
      this.getActiveContracts();
    }, err => {
      this.utilService.errorMessage('Error please try again');
      this.fileLoading = false;
    })
  }

}
